export default __webpack_public_path__ + "static/media/hebl_playeronly.06b2585f.png";